<template>
  <van-popup class="rank-pop" v-model="isShowRankData" round :closeable="true" position="bottom"
    :style="{ height: '66%', overflow: 'hidden' }">
    <van-tabs class="rank-tabs" v-model="activeTab" @change="changeTabFunc" type="line" :border="true" line-width="0" line-height="0">
      <van-tab v-for="(item, index) in rankTitle" :key="index" :title="item">
        <div class="sort">
          <div class="sort-text">礼物赠送、弹幕发言均可获得贡献值哦！</div>
          <div class="sort-btn" :class="{'sortrevers': rankListData[activeTab].orderType != 1}" @click="listSortFunc">贡献值<i class="sort-icon" style="margin-left: 3px;"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2.41536 8.86197C2.65998 8.67009 3.013 8.7111 3.20488 8.95572L4.66381 10.8116V1.56294C4.66381 1.2524 4.91576 1.00046 5.22629 1.00046C5.53683 1.00046 5.78877 1.2524 5.78877 1.56294V12.4375C5.78877 12.6777 5.63643 12.8901 5.40939 12.9692C5.3508 12.9897 5.28781 13 5.22629 13C5.05638 13 4.89232 12.9238 4.78393 12.7847L2.32015 9.65149C2.12827 9.40834 2.17074 9.05386 2.41536 8.86197ZM8.57773 1.03122C8.8033 0.952119 9.05525 1.02682 9.20319 1.21578L11.667 4.34896C11.8589 4.59212 11.8164 4.9466 11.5718 5.13848C11.3286 5.33037 10.9741 5.28936 10.7822 5.04474L9.3233 3.18885V12.4375C9.3233 12.7481 9.07136 13 8.76083 13C8.45029 13 8.19835 12.7481 8.19835 12.4375V1.56294C8.19981 1.32418 8.35215 1.11032 8.57773 1.03122Z" :fill="rankListData[activeTab].orderType == 1?'#666':'#000'"/>
          </svg></i></div>
        </div>
      </van-tab>
    </van-tabs>
    <van-pull-refresh class="rank-list-container" :id="'rank-list-container'+i" v-model="refreshing" loading-text="正在获取最新榜单..." @refresh="onRefresh" v-for="(itemList, i) in rankTitle" :key="i" v-show="activeTab == i">
      <van-list v-model="loading" :finished="rankListData [activeTab].rankFinished" finished-text="没有更多数据了哦~"
        @load="onLoad">
        <section class="rank-list">
          <div v-for="(item, index) in currentList" :key="index" class="list">
            <div class="list-item">
              <div class="list-info">
                <div class="rank-number">{{ index + 1 }}</div>
                <div class="list-avatar"><img :src="item.logo" @error="loadUserDefaultImg" class="avatar-img"
                    alt=""><img :src="touArr1[index].imgtou" alt="" class="avatar-border" v-if="index < 3" /></div>
                <div class="list-username">
                  <span class="nickname">{{ item.nickName }}</span>
                  <img :src="getLevlIcon(item.level)" alt="" class="vm_giftIcon" v-if="item.level > 0 && item.level < 11">
                  <span v-if="item.activeLevel && item.activeLevel != 0" class="activelevel"><img :src="getActiveLevelIcon(item.activeLevel)" alt="" class="activelevel-bg"><span class="activelevel-num">{{ item.activeLevel }}</span></span>
                </div>
              </div>
              <div class="list-score">{{ item.totalYd }}</div>
            </div>
          </div>
        </section>
      </van-list>
    </van-pull-refresh>
  </van-popup>
</template>

<script>
import APIS from '../../http/apis';
import GetUtils from "../../utils/utils";
import userDefaultImg from '../../assets/images/avatar2.png';
export default {
  name: "rankList",
  props: {
    isShowRank: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    isShowRankData: {
      get() {
        this.$nextTick(() => {
          this.rankTitle.forEach((el, index)=>{
            GetUtils.touchScroll("rank-list-container"+index);
          })
        });
        return this.isShowRank;
      },
      set(newValue) {
        this.$emit("closeRank");
      }
    },
    currentList() {
      return this.rankListData[this.activeTab].rankList;
    },
  },
  data() {
    return {
      activeTab: 0,
      rankTitle: ['日榜', '月榜', '总榜'],
      rankListData: [{
        rankList: [],
        rankPage: 1,
        rankFinished: false,
        rankVisited: false,
        orderType: 1
      },
      {
        rankList: [],
        rankPage: 1,
        rankFinished: false,
        rankVisited: false,
        orderType: 1
      },
      {
        rankList: [],
        rankPage: 1,
        rankFinished: false,
        rankVisited: false,
        orderType: 1
      }],
      isFirstLoad: true,
      loading: false,
      refreshing: false,

      touArr1: [
        { imgtou: require('../../assets/images/avatar_001.png') },
        { imgtou: require('../../assets/images/avatar_002.png') },
        { imgtou: require('../../assets/images/avatar_003.png') }
      ],
    }
  },
  methods: {
    async getRankList(dateType, pageNo, orderType) {
      let res = await APIS.giftTopAll({ apiName: "giftTopAll", pageSize: 30, dateType: dateType, pageNo: pageNo, orderType: orderType })

      if (res.data.listGift && res.data.listGift.length > 0) {
        this.rankListData[this.activeTab].rankList.push(...res.data.listGift);
      } else {
        this.rankListData[this.activeTab].rankFinished = true;
      }
      this.isFirstLoad = false;
    },
    changeTabFunc() {
      if (!this.rankListData[this.activeTab].rankVisited) {
        this.rankListData[this.activeTab].rankVisited = true;
        if (this.activeTab != 0) {
          this.getRankList(this.activeTab + 1, 1, 1);
        }
      }
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.rankListData[this.activeTab].rankList = [];
          this.rankListData[this.activeTab].rankPage = 1;
          this.rankListData[this.activeTab].rankFinished = false;
          this.refreshing = false;
        } else {
          if (!this.isFirstLoad) {
            this.rankListData[this.activeTab].rankPage += 1;
          }
        }
        this.getRankList(this.activeTab + 1, this.rankListData[this.activeTab].rankPage, this.rankListData[this.activeTab].orderType);
        this.loading = false;

        if (this.rankListData[this.activeTab].rankFinished) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      this.loading = true;
      this.onLoad();
    },
    listSortFunc() {
      if(this.rankListData[this.activeTab].orderType == 1) {
        this.rankListData[this.activeTab].orderType = 2;
      } else {
        this.rankListData[this.activeTab].orderType = 1;
      }
      this.refreshing = true;
      this.onLoad();
    },
    loadUserDefaultImg(event) {
      event.target.src = userDefaultImg;
    },

    getLevlIcon(i) {
      return require("../../assets/image_2/icon/" + i + ".png");
    },
    getActiveLevelIcon(num) {
       let iconnum = Math.min(Math.ceil(num / 5), 15);
       return require("../../assets/image_2/activeLevel/" + iconnum + ".png");
    },
  },
}
</script>
<style lang="scss" scoped>
:deep(.van-tabs--line .van-tabs__wrap){
  height: auto!important;
}
:deep(.van-tabs__nav--line){
  padding: 20px 30px 15px 30px;
}
:deep(.van-tab){
  font-size: 16px;
  color: #999;
}
:deep(.van-tab--active){
  font-size: 20px;
  color: #333;
}
:deep(.van-popup__close-icon--top-right){
  top: 14px;
  right: 14px;
}
.sort {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  padding: 17px 12px;
  .sort-text {
    color: #999;
  }

  .sort-btn {
    color: #666;
    border-radius: 29px;
    background-color: #EFEFEF;
    padding: 2px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.sortrevers{
      color: #000;
    }
    .sort-icon{
      display: flex;
    }
  }
}

.rank-list-container {
  overflow: auto;
  height: calc(100% - 6.375rem);
  padding: 6px 14px;

  .rank-list {
    .list {
      font-size: 14px;

      .rank-number {
        color: #999;
        padding: 0 13px;
      }

      &:nth-child(1) {
        .rank-number {
          color: #FF2828;
        }
      }

      &:nth-child(2) {
        margin-top: 23px;
        .rank-number {
          color: #FF6C28;
        }
      }

      &:nth-child(3) {
        margin-top: 23px;
        .rank-number {
          color: #FFBB10;
        }
      }

      .list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .list-info {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .list-avatar {
            margin: 0 10px;
            position: relative;
            width: 38px;
            height: 38px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              position: absolute;
            }

            .avatar-img {
              overflow: hidden;
              border-radius: 38px;
              z-index: 0;
            }

            .avatar-border {
              width: 46.4px;
              height: 50.4px;
              top: -10px;
              left: -6px;
              z-index: 1;
            }
          }

          .list-username {
            color: #333;
            display: flex;
            align-items: center;
            .nickname {
              margin-right: 4px;
              max-width: 100px;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .vm_giftIcon {
              display: inline-block;
              height: 14px;
            }
            .activelevel{
              position: relative;
              height: 15px;
              margin-left: 4px;
              .activelevel-bg{
                height: 100%;
              }
              .activelevel-num{
                position: absolute;
                color: #fff;
                text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);
                font-size: 10px;
                font-weight: 500;
                left: 14px;
                width: 14px;
                height: 15px;
                line-height: 15px;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }
}
</style>